import { useTranslation as e } from "../../i18n.mjs";
import { ActionMenu as t } from "../action-menu/index.mjs";
import { FilePreview as n } from "../file-preview/index.mjs";
import { StaticCheckbox as r } from "@systemeio/components";
import "react";
import { twMerge as i } from "tailwind-merge";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/file-card/index.tsx
function s({ fileType: s, src: c, alt: l, name: u, secondaryText: d, style: f, selected: p, actionMenu: m, className: h, imageWidth: g, imageHeight: _, onSelect: v }) {
	let { t: y } = e();
	return /* @__PURE__ */ o("div", {
		className: i("relative flex flex-col rounded-lg", h),
		style: f,
		children: [/* @__PURE__ */ o("div", {
			"aria-checked": p,
			"aria-label": `${y("file_manager.select")}: ${u ?? l ?? ""}`,
			className: "focus-visible:focus-ring-primary relative flex flex-1 cursor-pointer flex-col rounded-lg outline-none",
			role: "checkbox",
			tabIndex: 0,
			onClick: () => v(!p),
			onKeyDown: (e) => {
				(e.key === " " || e.key === "Enter") && (e.preventDefault(), v(!p));
			},
			children: [
				/* @__PURE__ */ a(n, {
					src: c ?? "",
					fileType: s,
					alt: l,
					width: g,
					height: _,
					className: i("box-border shrink-0 rounded-lg border-2 border-transparent", p && "border-border-accent"),
					isThumbnail: !0
				}),
				/* @__PURE__ */ a("div", {
					className: "absolute top-2 left-2",
					children: /* @__PURE__ */ a(r, { checked: p })
				}),
				/* @__PURE__ */ a("div", {
					className: "text-text-primary mt-1 truncate overflow-clip text-base",
					title: u,
					children: u
				}),
				/* @__PURE__ */ a("div", {
					className: "text-text-secondary mt-1 truncate overflow-clip text-sm",
					title: d,
					children: d
				})
			]
		}), m && /* @__PURE__ */ a("div", {
			className: "absolute top-2 right-2",
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ a(t, {
				...m,
				menuItems: m.menuItems ?? []
			})
		})]
	});
}
//#endregion
export { s as FileCard };
